export var datepickerCalendarHeaderCellStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: v.calendarHeaderCellFontWeight,
      height: v.calendarHeaderCellHeight,
      width: v.calendarHeaderCellWidth,
      padding: v.calendarHeaderCellPadding,
      display: 'table-cell'
    };
  }
};
//# sourceMappingURL=datepickerCalendarHeaderCellStyles.js.map
